export const RESET = 'RESET';
export const SYSTEM_COLLAPSE = 'SYSTEM_COLLAPSE';
export const SYSTEM_EXPAND = 'SYSTEM_EXPAND';
// Validation-driven expand: reveals a folded region that hides an invalid cell.
// Unlike SYSTEM_EXPAND it bypasses the user-preference guard, but it is stored as
// SYSTEM_EXPAND state so it never overwrites the user's saved collapse preference.
export const FORCE_EXPAND = 'FORCE_EXPAND';
export const TOGGLE_COLLAPSE = 'TOGGLE_COLLAPSE';
export const USER_COLLAPSE = 'USER_COLLAPSE';
export const USER_EXPAND = 'USER_EXPAND';
